import { Button, Column, Grid } from "@carbon/react";
import { AvailableAndDisputeBalance } from "./AvailableAndDisputeBalance";
import { InlineTable } from "./InlineTable";
import { Badge, Card, CurrencyDisplay } from "../../../components";

import { topUpData } from "../../../test-data/top-up-data";
import { payOutData } from "../../../test-data/pay-out-data";

export const View = (props) => {
  return (
    <Card className="balance-table--container">
      <Grid>
        <Column sm={4} md={8} lg={8}>
          <AvailableAndDisputeBalance
            title="Available balance"
            subtitle=""
            navigateButton={
              <Button className="switchapp-themed" size="sm" kind="tertiary">
                Add to balance
              </Button>
            }
            data={[
              {
                amount: 350000,
                currencySymbol: "₦",
                description: "Payouts to be made",
              },
              {
                amount: 50000,
                currencySymbol: "₦",
                description: "Disputes",
              },
            ]}
            total={400000}
            totalCurrencySymbol={"₦"}
          />
        </Column>

        <Column sm={4} md={8} lg={8}>
          <InlineTable
            title={"Top-Ups"}
            subtitle={"Funds added to your SwitchApp account"}
            viewAllUrl={"/balances/top-ups"}
            data={topUpData}
            total={207000}
            totalCurrencySymbol={"₦"}
            renderRow={(item) => (
              <>
                <td>
                  <Badge
                    text={item.status}
                    statusColor={
                      item.status === "Paid"
                        ? "success"
                        : item.status === "Processing"
                        ? "secondary"
                        : "danger"
                    }
                    smallFont
                  />
                </td>
                <td>{item.gatewayId}</td>
                <td>{item.date}</td>
                <td>{item.description}</td>
                <td>
                  <CurrencyDisplay
                    currencySymbol={item.currencySymbol}
                    amount={item.amount}
                    fontSize={14}
                  />
                </td>
              </>
            )}
          />
        </Column>
      </Grid>

      <div className="row-divider" />

      <Grid>
        <Column sm={4} md={8} lg={8}>
          <AvailableAndDisputeBalance
            title="Disputes Balance"
            subtitle=""
            data={[
              {
                amount: 35000,
                currencySymbol: "₦",
                description: "Flutterwave ",
              },
              {
                amount: 15000,
                currencySymbol: "₦",
                description: "Paypal",
              },
            ]}
            total={50000}
            totalCurrencySymbol={"₦"}
          />
        </Column>

        <Column sm={4} md={8} lg={8}>
          <InlineTable
            title={"Payouts"}
            subtitle={"Funds going out of your SwitchApp account"}
            viewAllUrl={"/balances/payouts"}
            data={payOutData}
            total={350000}
            totalCurrencySymbol={"₦"}
            renderRow={(item) => (
              <>
                <td>
                  <Badge
                    text={item.status}
                    statusColor={
                      item.status === "Paid"
                        ? "success"
                        : item.status === "Processing"
                        ? "secondary"
                        : "danger"
                    }
                    smallFont
                  />
                </td>
                <td>{item.gatewayId}</td>
                <td>{item.date}</td>
                <td>{item.description}</td>
                <td>
                  <CurrencyDisplay
                    currencySymbol={item.currencySymbol}
                    amount={item.amount}
                    fontSize={14}
                  />
                </td>
              </>
            )}
          />
        </Column>
      </Grid>
    </Card>
  );
};
